import React from 'react';
import Select2 from 'react-select2-wrapper';
import PropTypes from 'prop-types';

import 'select2/dist/css/select2.min.css';
import './multiselect.scss';

const index = ({ onChange, disabled, className, name, value, placeholder, options, allowClear, width="100%" }) => {

  return (
    <Select2
      multiple
      className={className}
      style={{width}}
      data={options}
      value={value}
      name={name}
      disabled={disabled}
      onChange={(e) => { onChangeTarget(e.target.options, onChange, name); }}
      options={{
        placeholder: placeholder,
        allowClear: allowClear
      }}
    />
  )
}

const onChangeTarget = (option, onChange, name) => {
  let options = option;
  let selected = [];
  for (let i = 0, l = options.length; i < l; i++) {
    if (options[i].selected) {
      selected.push(options[i].value);
    }
  }
  onChange({ target: { name: name, value: selected } });
}

export default index;


// ----* input propTypes set *----
index.propTypes = {
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  options: PropTypes.array,

  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
}

// * ----- index defaultProps  set * -----
index.defaultProps = {
  options: [],
  value: [],
  allowClear: false,
  className: 'form-control',
  disabled: false
};